import ttf from './Montserrat.ttf';
import woff from './Montserrat.woff';
import woff2 from './Montserrat.woff2';

export default {
  name: 'Montserrat',
  variant: 'Regular',
  ttfUrl: ttf,
  woffUrl: woff,
  woff2Url: woff2,
} as const;
